import { Component, } from '@angular/core';
import { Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { HomePage } from '../pages/home/home';
import { ResetPasswordPage } from '../pages/reset-password/reset-password';
import { PublicShareComponent } from '../components/public-share/public-share';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { ConfigApiServiceProvider } from '../providers/config-api-service/config-api-service';
import { DrivePage } from '../pages/drive/drive';
import { MasterPage } from '../pages/master/master';
import { DriveServiceProvider } from '../providers/drive-service/drive-service';

@Component({
  templateUrl: 'app.html'
})
export class DriveApp {
  pwdresetParamsIndex = 2; // url sample: http://localhost:8100/?server=prod&desktype=workflow&email=arifa@prodcast.comresetPassword
  // pwdresetEmailParamIndex = 0; // url sample: http://localhost:8100/?server=prod&desktype=workflow&email=arifa@prodcast.comresetPassword
  rootPage: any = '';
  resetPageParams: any = '';
  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public events: Events, private configApiservice: ConfigApiServiceProvider, private driveSerive: DriveServiceProvider) {
    this.events.subscribe('summaryMethod', (identityComponent, pullParams) => {
      this.configApiservice.pullRequest(pullParams, (respdata) => {
        this.events.publish(identityComponent, respdata)
      })
    })
    this.events.subscribe('postMethod', (identityComponent, pushParams) => {
      this.configApiservice.pushRequest(pushParams, (respdata) => {
        this.events.publish(identityComponent, respdata)
      })
    })

    this.events.subscribe('SeverHost', (identityLink) => {
      var hostLink = this.configApiservice.project_config.nodeServer;
      this.events.publish(identityLink, hostLink)
    })

    window.addEventListener('message', (event: any) => {
      if (event.data.storeTemplates != "" && event.data.storeTemplates != undefined) {
        this.driveSerive.storeWrap.storeTemplates = event.data.storeTemplates;
      }
      if (event.data.exportTemplateData != "" && event.data.exportTemplateData != undefined) {
        this.configApiservice.exportTempalateJSON = event.data.exportTemplateData
      } else if (event.data.exportFolderData != "" && event.data.exportFolderData != undefined) {
        this.configApiservice.exportFolderJSON = event.data.exportFolderData
      } else if (event.data.importFolderData != "" && event.data.importFolderData != undefined) {
        this.driveSerive.broadcastInfo({ src: 'iframeData', event: 'folderTemplateCreateAuto', status: true, importFolderData: event.data.importFolderData });
      } else if (event.data.importTemplateData != "" && event.data.importTemplateData != undefined) {
        this.driveSerive.broadcastInfo({ src: 'iframeData', event: 'folderTemplateCreateAuto', status: true, importFolderData: event.data.importFolderData });
      } else if (event.data.FolderName != "" && event.data.FolderName != undefined) {
        this.configApiservice.excelTemplateStatus = true;
        this.driveSerive.broadcastInfo({ src: 'iframeData', event: 'excelTemplateauto', status: true, folderName: event.data.FolderName, template: event.data.template, excelFile: event.data.ExcelFile });
      } else if (event.data === "gridRefresh") {
        this.driveSerive.broadcastInfo({ src: 'grid-main', event: 'gridRefresh', status: true });
      } else if (event.data.childLoad === "init-child-app") {
        let sendParams = { 'accessToken': this.configApiservice.configureService.getAccessToken(),'accessType':this.driveSerive.objUserLoginDetails['message'] }
        event.source.postMessage(sendParams, event.origin);
      }else if (event.data === "closeHolder") {
        this.driveSerive.broadcastInfo({ src: 'comp-main', event: 'closeHolder', status: true });
      }
      if (event.data.HeaderDetails != "" && event.data.HeaderDetails != undefined) {
        this.driveSerive.broadcastInfo({ src: 'defaultProps', event: 'pushParamsValue', params: event.data.HeaderDetails });
      }

      if(event.data.src == "libapicall"){
        if(event.data.CustompostMethod != "" && event.data.CustompostMethod != undefined){
          this.configApiservice.pushRequest(event.data.CustompostMethod, (respdata) => {
            let sendParams = respdata
            event.source.postMessage({"src":'submitSuccess',"postFormData":sendParams,'identityComponent':event.data.identityComponent}, event.origin);
            if(event.data.params){
              this.driveSerive.broadcastInfo({ src: 'grid-main', event: 'gridRefresh', status: true });
            }
          })
          event.data.CustompostMethod = '';
        }
        if(event.data.CustomsummaryMethod != "" && event.data.CustomsummaryMethod != undefined){
          this.configApiservice.pullRequest(event.data.CustomsummaryMethod, (respdata) => {
            let sendParams = respdata
            event.source.postMessage({"src":'drive',"summaryData":sendParams,'identityComponent':event.data.identityComponent}, event.origin);
          })
          event.data.CustomsummaryMethod = '';
        }
      }
    })

    //  = this.importTempalateJSON
    console.log(this.configApiservice.importTempalateJSON)
    if (window.location.search != "") {
      for (var i = 0; i < window.location.search.substring(1).split('&').length; i++) {
        if (window.location.search.substring(1).split('&')[i].split("=")[0] == 'email') {
          this.rootPage = ResetPasswordPage;
          return;
        }
        else if (window.location.search.substring(1).split('&')[i].split("=")[0] == 'ShareID') {
          this.driveSerive.presentLoading();
          this.rootPage = PublicShareComponent;
          return;
        }
        else if (window.location.search.substring(1).split('&')[i].split("=")[0] == 'RecoverPassword') {
          this.rootPage = ForgotPasswordPage;
          return;
        }
        else if (window.location.search.substring(1).split('&')[i].split("=")[0] == 'NewAccountMail') {
          this.rootPage = HomePage;
          return;
        }
      }
    }
    // else{
    this.rootPage = HomePage;
    // }
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }
  customFunction(e) {

  }
  ngAfterViewInit() {
    // console.log(this.router.snapshot.queryParamMap.has('user_id'));
    // console.log(this.router.snapshot.queryParamMap.get('user_id'));
    // console.log(this.router.snapshot.queryParamMap.getAll('user_id'));
    if (window.location.search != "") {

    }
  }

  ngOnDestroy() {
    this.events.subscribe('summaryMethod');
    this.events.subscribe('postMethod');
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts